import styled from 'styled-components';

import { SkeletonButton } from '@xing-com/skeleton';
import { scale260, spaceM, spaceL } from '@xing-com/tokens';

const ContentSwitcherContainer = styled.div`
  overflow: hidden;
  padding: ${spaceL} 0;
`;

const ContentSwitcherButtonsContainer = styled.div`
  display: flex;
  gap: ${spaceM};
  width: 200vh;
`;

const ContentSwitcherButton = styled(SkeletonButton)`
  max-width: ${scale260};
`;

export const Styled = {
  ContentSwitcherContainer,
  ContentSwitcherButtonsContainer,
  ContentSwitcherButton,
};
